import React from 'react';

class ErrorBoundary extends React.Component {
    constructor(props) {
        super(props);
        this.state = { hasError: false, error: null, errorInfo: null };
    }

    static getDerivedStateFromError(error) {
        return { hasError: true };
    }

    componentDidCatch(error, errorInfo) {
        this.setState({
            error: error,
            errorInfo: errorInfo
        });

        // Log error to console in development
        if (process.env.NODE_ENV === 'development') {
            console.error('ErrorBoundary caught an error:', error, errorInfo);
        }
    }

    render() {
        if (this.state.hasError) {
            return (
                <main className="error-boundary">
                    <div className="error-container">
                        <p className="error-kicker">Bi Gayrimenkul</p>
                        <h1 className="error-title">Ankara Etimesgut Gayrimenkul Danışmanlığı</h1>
                        <p className="error-message">
                            Ankara Etimesgut Bağlıca bölgesinde satılık ve kiralık konut,
                            ticari gayrimenkul ilanları ve yatırım danışmanlığı.
                        </p>
                        <nav className="error-actions" aria-label="Site menüsü">
                            <a className="btn btn-primary" href="/">Ana Sayfa</a>
                            <a className="btn btn-secondary" href="/properties">İlanlar</a>
                            <a className="btn btn-secondary" href="/hakkimizda">Hakkımızda</a>
                            <a className="btn btn-secondary" href="/iletisim">İletişim</a>
                        </nav>
                        <p className="error-message">
                            Bağlıca, 1239. Sk. No:2/2, Etimesgut, Ankara ·
                            {' '}<a href="tel:+905421401491">0542 140 14 91</a>
                        </p>
                        <button
                            type="button"
                            className="btn btn-secondary"
                            onClick={() => window.location.reload()}
                        >
                            Sayfayı yenile
                        </button>
                        {process.env.NODE_ENV === 'development' && (
                            <details className="error-details">
                                <summary>Geliştirici Detayları</summary>
                                <pre className="error-stack">
                                    {this.state.error && this.state.error.toString()}
                                    <br />
                                    {this.state.errorInfo && this.state.errorInfo.componentStack}
                                </pre>
                            </details>
                        )}
                    </div>
                </main>
            );
        }

        return this.props.children;
    }
}

export default ErrorBoundary;
